export const pictures = [
    {
        id: 1,
        country: 'Франция',
        author: 'Марсель Руссо',
        title: 'Охота Амура',
        materials: 'Холст, масло (50x80)',
        price: '14 500 руб',
        image: '/assets/Франция/hunting.png',
    },
    {
        id: 2,
        country: 'Франция',
        author: 'Анри Селин',
        title: 'Дама с собачкой',
        materials: 'Акрил, бумага (50x80)',
        price: '16 500 руб',
        image: '/assets/Франция/ladyWithDog.png',
    },
    {
        id: 3,
        country: 'Франция',
        author: 'Франсуа Дюпон',
        title: 'Процедура',
        materials: 'Цветная литография (40x60)',
        price: '20 000 руб',
        image: '/assets/Франция/procedure.png',
    },
    {
        id: 4,
        country: 'Франция',
        author: 'Луи Детуш',
        title: 'Роза',
        materials: 'Бумага, акрил (50х80)',
        price: '12 000 руб',
        image: '/assets/Франция/rose.png'
    },
    {
        id: 5,
        country: 'Франция',
        author: 'Франсуа Депон',
        title: 'Птичья трапеза',
        materials: 'Цветная литография (40x60)',
        price: '22 500 руб',
        image: '/assets/Франция/birdMeal.png',
    },
    {
        id: 6,
        country: 'Франция',
        author: 'Пьер Моранж',
        title: 'Пейзаж с рыбой',
        materials: 'Цветная литография (40x60)',
        price: '22 500 руб',
        image: '/assets/Франция/landscapeWithFish.png',
    },
      
    {
        id: 7,
        country: 'Германия',
        author: 'Курт Вернер',
        title: 'Над городом',
        materials: 'Цветная литография (40х60)',
        price: '16 000 руб',
        image: '/assets/Германия/aboveTheCity.png',
    },
    {
        id: 8,
        country: 'Германия',
        author: 'Макс Рихтер',
        title: 'Птенцы',
        materials: 'Холст, масло (50х80)',
        price: '14 500 руб',
        image: '/assets/Германия/chicks.png',
    },
    {
        id: 9,
        country: 'Германия',
        author: 'Мартин Майер',
        title: 'Среди листьев',
        materials: 'Цветная литография (40х60)',
        price: '20 000 руб',
        image: '/assets/Германия/amongTheLeaves.png',
    },
    {
        id: 10,
        country: 'Германия',
        author: 'Герман Беккер',
        title: 'Яркая птица',
        materials: 'Цветная литография (40х60)',
        price: '13 000 руб',
        image: '/assets/Германия/brightBird.png',
    },
    {
        id: 11,
        country: 'Германия',
        author: 'Вульф Бауэр',
        title: 'Дятлы',
        materials: 'Бумага, акрил (50х80)',
        price: '20 000 руб',
        image: '/assets/Германия/woodpeckers.png',
    },
    {
        id: 12,
        country: 'Германия',
        author: 'Вальтер Хартманн',
        title: 'Большие воды',
        materials: 'Бумага, акрил (50х80)',
        price: '23 000 руб',
        image: '/assets/Германия/bigWaters.png',
    },

    {
        id: 13,
        country: 'Англия',
        author: 'Пол Смит',
        title: 'Дикий зверь',
        materials: 'Акварель, бумага (50х80)',
        price: '19 500 руб',
        image: '/assets/Англия/wildBeast.png',
    },
    {
        id: 14,
        country: 'Англия',
        author: 'Джон Уайт',
        title: 'Скалистый берег',
        materials: 'Цветная литография (40х60)',
        price: '17 500 руб',
        image: '/assets/Англия/rockyCoast.png',
    },
    {
        id: 15,
        country: 'Англия',
        author: 'Джим Уотсон',
        title: 'Река и горы',
        materials: 'Акварель, бумага (50х80)',
        price: '20 500 руб',
        image: '/assets/Англия/riverAndMountains.png',
    },
    {
        id: 16,
        country: 'Англия',
        author: 'Юджин Зиллион',
        title: 'Белый попугай',
        materials: 'Цветная литография (40х60)',
        price: '15 500 руб',
        image: '/assets/Англия/whiteParrot.png',
    },
    {
        id: 17,
        country: 'Англия',
        author: 'Эрик Гиллман',
        title: 'Ночная рыба',
        materials: 'Бумага, акрил (50х80)',
        price: '12 500 руб',
        image: '/assets/Англия/nightFish.png',
    },
    {
        id: 18,
        country: 'Англия',
        author: 'Альфред Барр',
        title: 'Рыжий кот',
        materials: 'Цветная литография (40х60)',
        price: '21 500 руб',
        image: '/assets/Англия/redCat.png',
    },
];

export const countries = ['Франция', 'Германия', 'Англия'];
